import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import withState from 'recompose/withState';
import mapProps from 'recompose/mapProps';
import Modal from 'react-modal';
import { Map } from 'immutable';
import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import ApolloClient from 'apollo-client';
import { Field, reduxForm } from 'redux-form';
import { OrganizationActions } from '../../../actions/organization';
import InputField from '../../form/InputField';
import { validateAndDispatch } from '../../../helpers/form';
import BasicButton from '../BasicButton/';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 500,
    maxWidth: 700,
  },
  overlay: {
    zIndex: 1031,
    background: 'rgba(0, 0, 0, 0.6)',
  },
};

@reduxForm({
  form: 'createOrganization',
  destroyOnUnmount: true,
  enableReinitialize: false,
})
@withApollo
class CreateOrganizationForm extends PureComponent {
  static propTypes = {
    onSuccess: PropTypes.func.isRequired,
    reset: PropTypes.func,
    handleSubmit: PropTypes.func,
    submitting: PropTypes.func.isRequired,
    error: PropTypes.func,
    currentUser: PropTypes.instanceOf(Map),
    client: PropTypes.instanceOf(ApolloClient),
  };

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  async submit(values, dispatch) {
    const { onSuccess, currentUser, client } = this.props;

    const validation = {
      organizationName: [{ rule: 'required', label: 'organization name' }],
    };

    const createOrganizationFormObject = {
      organizationName: values.organizationName,
    };

    const userId = currentUser.get('id');

    try {
      const response = await validateAndDispatch(
        dispatch,
        OrganizationActions.createOrganization(
          createOrganizationFormObject,
          userId,
        ),
        validation,
        values,
      );

      // populate apollo cache
      const queryOrganizations = gql`
        query organizations {
          organizations {
            id
            name
          }
        }
      `;

      let data = null;
      try {
        data = client.readQuery({ query: queryOrganizations });
      } catch (e) {
        data = { organizations: [] };
      }
      const newOrganization = Object.values(
        response.result.entities.organizations,
      )[0];

      client.writeQuery({
        query: queryOrganizations,
        data: {
          ...data,
          organizations: [
            ...data.organizations,
            {
              id: newOrganization.id,
              name: newOrganization.name,
              __typename: 'Organization',
              [Symbol('id')]: `Organization:${newOrganization.id}`,
            },
          ],
        },
      });

      if (onSuccess) onSuccess();
    } catch (e) {
      throw e;
    }
  }

  render() {
    const { handleSubmit, submitting } = this.props;

    return (
      <form>
        <h4>Create Organization</h4>
        <fieldset className="form-group">
          <Field
            name="organizationName"
            component={InputField}
            label={'Organization Name'}
            className="form-control"
            placeholder={'Organization Name'}
            dataTest="organizationName"
          />
        </fieldset>
        <button
          className="btn btn-primary modal-button-full"
          onClick={handleSubmit(this.submit)}
          disabled={submitting}
          data-test="createOrganizationSubmit"
        >
          {submitting && <i className="fa fa-cog fa-spinner fa-spin" />} Create
          Organization
        </button>
      </form>
    );
  }
}

const enhance = compose(
  withState('isOpened', 'setOpen', false),
  mapProps(({ setOpen, ...rest }) => ({
    open: () => setOpen(() => true),
    close: () => setOpen(() => false),
    toggle: () => setOpen(s => !s),
    ...rest,
  })),
  withHandlers({
    handleRequestClose: props => () => props.close(),
    handleClick: props => _event => props.open(),
  }),
);

const CreateOrganizationButton = enhance(
  ({ handleClick, handleRequestClose, isOpened, currentUser }) => {
    return (
      <div>
        <BasicButton
          className="btn btn-primary"
          callback={handleClick}
          data-test="createOrganization"
        >
          <i className="fa fa-plus" /> Create Organization
        </BasicButton>
        <Modal
          isOpen={isOpened}
          shouldCloseOnOverlayClick
          onRequestClose={handleRequestClose}
          style={customStyles}
        >
          <div>
            <div className="fs-modal-close">
              <div onClick={handleRequestClose} className="modal-close-btn">
                <i className="fa fa fa-times fa-2x" />
              </div>
            </div>
            <CreateOrganizationForm
              currentUser={currentUser}
              onSuccess={handleRequestClose}
            />
          </div>
        </Modal>
      </div>
    );
  },
);

export default connect()(CreateOrganizationButton);



// WEBPACK FOOTER //
// ./src/components/buttons/CreateOrganizationButton/CreateOrganizationButton.js